export default {
	openedModals: state => state.openedModals,
};
